// extracted by mini-css-extract-plugin
export var emptyState = "_5g-d";
export var statCard = "_5g-c";
export var table = "_5g-0";
export var tableCell = "_5g-4";
export var tableCellClickable = "_5g-5 _5g-4";
export var tableCellDefault = "_5g-6 _5g-4";
export var tableCellEmpty = "_5g-8";
export var tableCellWithValue = "_5g-7";
export var tableContainer = "_5g-e";
export var tableHeaderWeight = "_5g-1";
export var tableHeaderZone = "_5g-2";
export var tableRowHeader = "_5g-3";
export var viewModeButton = "_5g-9";
export var viewModeButtonActive = "_5g-a _5g-9";
export var viewModeButtonInactive = "_5g-b _5g-9";